import { css } from '@emotion/react';

export const chipStyleOverride = css`
  @container submission-details-view (max-width: 950px) {
    max-width: 60px;
  }
`;
